var render, staticRenderFns
import script from "./VSelect.vue?vue&type=script&lang=ts"
export * from "./VSelect.vue?vue&type=script&lang=ts"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=1cf64671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf64671",
  null
  
)

export default component.exports